var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", [_vm._v(_vm._s(_vm.title))]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "fal fa-search",
                      placeholder: "Search",
                      "single-line": "",
                      "hide-details": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    options: _vm.pagination,
                    headers: _vm.headers,
                    items: _vm.datasource,
                    search: _vm.search,
                    loading: _vm.myloading,
                    "show-select": _vm.selection,
                  },
                  on: {
                    "update:options": function ($event) {
                      _vm.pagination = $event
                    },
                    input: _vm.emit,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function (props) {
                        return [
                          _vm.selection
                            ? _c(
                                "td",
                                [
                                  _c("v-checkbox", {
                                    attrs: { primary: "", "hide-details": "" },
                                    model: {
                                      value: props.selected,
                                      callback: function ($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.id))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.name)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.login)),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectionModel,
                    callback: function ($$v) {
                      _vm.selectionModel = $$v
                    },
                    expression: "selectionModel",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        type: "warning",
                      },
                      slot: "no-results",
                    },
                    [
                      _vm._v(
                        '\n          Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.\n      '
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }